import { getCookie } from '@/router/index.js';
import { get_domain_style } from '@/main';

export default {
  name: 'RegisterView',
  data: () => ({
    form: {
      name: '',
      surname: '',
      email: '',
      password: '',
      confirm_password: '',
      client_type: '',
    },
    password_visible: false,
    confirm_password_visible: false,
    errors: {},
    client_types: [],
    roles: [],
    loading: false,
    meets_criteria: {
      length: false,
      lowercase: false,
      uppercase: false,
      special: false,
    },
    password_focused: false,
    csrfToken : ''

  }),

  mounted() {
    this.fetch_roles();
    this.fetch_client_types();
    this.csrfToken = getCookie("csrftoken");
  },

  computed: {
    styleConfig() {
      return get_domain_style();
    },
    selected_client_type() {
      return this.client_types.find(type => type.id == this.form.client_type);
    },
  },

  watch: {
    'form.password'(newVal) {
      this.check_password_criteria(newVal);
    },
  },


  methods: {


    password_visibility() {
      this.password_visible = !this.password_visible;
    },

    confirm_password_visibility() {
      this.confirm_password_visible = !this.confirm_password_visible;
    },

    check_password_criteria(password) {
      this.meets_criteria = {
        length: password.length >= 8,
        lowercase: /[a-z]/.test(password),
        uppercase: /[A-Z]/.test(password),
        special: /[!@#$%^&*(),.?":{}|<>]/.test(password),
      };
    },

    validate_email() {
      const email = this.form.email.toLowerCase().trim();
      if (!email || !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)) {
        this.$notyf.error('Invalid email');
        return false;
      }
      this.form.email = email;
      return true;
    },


    validate_password() {
      if (!this.form.password) {
        this.$notyf.error('Password must be at least 8 characters long');
        return false;
      }
      else if (!/[a-z]/.test(this.form.password)) {
        this.$notyf.error('Password must contain at least one lowercase letter');
        return false;
      }
      else if (this.form.password !== this.form.confirm_password) {
        this.$notyf.error('Passwords do not match');
        return false;
      }
      else if (!Object.values(this.meets_criteria).every(Boolean)) {
        this.$notyf.error('Password does not meet required criteria.');
        return false;
      }
      return true;
    },


    validate_form() {
      let is_valid = true;
      if (!this.form.name) {
        this.$notyf.error('Name is required');
        is_valid = false;
      }
      else if (!this.form.surname) {
        this.$notyf.error('Surname is required');
        is_valid = false;
      }
      else if (!this.form.client_type) {
        this.$notyf.error('Please select type');
        is_valid = false;
      }
      else if (!this.validate_email()) is_valid = false;
      else if (!this.validate_password()) is_valid = false;
      return is_valid;
    },

    async fetch_roles() {
      const url = process.env.VUE_APP_API_BASE_URL + '/aic_one_api/system_management/get_all_roles/';
      try {
        const res = await fetch(url, {
          method: 'GET',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': this.csrfToken

           },
        });
        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
        const data = await res.json();
        if (data.status === 'success') {
          this.roles = data.data;
        } else {
          this.$notyf.info('Failed to fetch roles');

        }
      } catch (error) {
        this.$notyf.info('Error fetching roles');

      }
    },

    async fetch_client_types() {
      const url = process.env.VUE_APP_API_BASE_URL + '/aic_one_api/system_management/get_all_client_types';
      try {
        const res = await fetch(url, {
          method: 'GET',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json',
                    'X-CSRFToken': this.csrfToken,
           },
        });
        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
        const data = await res.json();
        this.client_types = data.data;
      } catch (error) {
        this.$notyf.info('Error fetching client types');

      }
    },

    async submit_form() {

      if (!this.validate_form()) return;

      localStorage.removeItem('role');

      const selected_type = this.selected_client_type;

      // Decide role based on client type name
      if (selected_type && selected_type.name.toLowerCase() === 'organization') {
        const super_admin_role = this.roles.find(role => role.name.toLowerCase() === 'organization admin');
        if (super_admin_role) {
          this.form.role = super_admin_role.id;
        }
      } else {
        const user_role = this.roles.find(role => role.name.toLowerCase() === 'user');
        if (user_role) {
          this.form.role = user_role.id;
        }
      }
      this.loading = true;


      const payload = {
        first_name: this.form.name,
        last_name: this.form.surname,
        email: this.form.email,
        role_id: this.form.role,
        password: this.form.password,
        confirm_password: this.form.confirm_password,
        client_type_id: Number(this.form.client_type),
      };


      try {
        const url = process.env.VUE_APP_API_BASE_URL + '/aic_one_api/system_management/register_user/';
        const cookie_url = process.env.VUE_APP_API_BASE_URL + '/aic_one_api/system_management/get_csrf_token/';

        await fetch(cookie_url, {
          method: 'GET',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            'X-Page-URL': window.location.href,
            'X-CSRFToken': this.csrfToken,
          },
        });
        this.csrfToken = getCookie('csrftoken');

        const res = await fetch(url, {
          method: 'POST',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': this.csrfToken

           },
          body: JSON.stringify(payload),
        });
        const data = await res.json();
        if (data.status === 'success') {
        this.$notyf.success('Your account has been created successfully.');
          this.$router.push('/');
        } else {
          // Optional: show error returned from API
          this.$notyf.info(data.message || 'Registration failed. Please try again.');
        }
      } catch (error) {
        this.$notyf.info('Registration failed: ');

      } finally {
        this.loading = false;
      }
    },
  },
};
